<style scoped>
.legaldocflow {
  background-color:white;
  background-repeat: no-repeat;
  background-size: cover;
  padding: 0px;
}


.legaldocflow .left-section{
  background: rgb(5,22,81);
  
}
.legaldocflow .right-section{
  padding-top: 20px;
}
.legaldocflow .left-section .inner-left{
  margin-top: 230px;
  margin-left: 5px;
  margin-right: 5px;
  margin-bottom: 0px;
  padding-left: 40px;
  padding-right: 30px;
  

  color: #fff;
}
.legaldocflow .card-height{
  margin: auto;
  margin-top: 40px;
  
}
.legaldocflow .btn{
  width: 100%;
  background: rgb(5,22,81);
}
.legaldocflow .left-section. h1{
  margin-top:-5px;
  color: #fff;

}


.capture672 .bg-image {
  height: 100%; }

.capture672 .gradient-mask {
  /**
  background: -webkit-linear-gradient(rgba(0, 47, 75, 0.8) 0%, rgba(220, 66, 37, 0.8) 100%);
  background: -o-linear-gradient(rgba(0, 47, 75, 0.8) 0%, rgba(220, 66, 37, 0.8) 100%);
  background: -webkit-gradient(linear, left top, left bottom, from(rgba(0, 47, 75, 0.8)), to(rgba(220, 66, 37, 0.8)));
  background: linear-gradient(rgba(0, 47, 75, 0.8) 0%, rgba(220, 66, 37, 0.8) 100%);
  **/
  background: -webkit-linear-gradient(rgba(54, 194, 117, 0.8) 0%, rgba(220, 66, 37, 0.8) 100%);
  background: -o-linear-gradient(rgba(54, 194, 117, 0.8) 0%, rgba(220, 66, 37, 0.8) 100%);
  background: -webkit-gradient(linear, left top, left bottom, from(rgba(0, 47, 75, 0.8)), to(rgba(220, 66, 37, 0.8)));
  background: linear-gradient(rgba(54, 194, 117, 0.8) 0%, rgba(220, 66, 37, 0.8) 100%);
  /* Chrome10+,Safari5.1+ */
  /* Opera 11.10+ */
  /* IE10+ */
  /* W3C */
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#002f4b', endColorstr='#00000000', GradientType=0);
}

.capture672 .theme--light.v-sheet {
    background-color: transparent;
    border-color: #fff;
    color: #fff;
}
.capture672  input:-internal-autofill-selected {
      background-color: transparent !important;
      background-image: none !important;
      color: #fff !important;
  }

.capture672 .theme--light.v-label {
    background-color: transparent;
    color: #fff !important;
  }
.capture672  .v-label.theme--light{
  color: #fff
  }

.capture672  .theme--light .v-icon {
      color: #fff;
  }
.capture672  .theme--light .v-label {
      color: #fff;
  }
.capture672  .v-text-field__slot input {
      color: red
    }
.capture672 .button-green-gradient {
      background: #00d301;
      background: -webkit-linear-gradient(-196deg,#00d301,#36c275 50%,#00a562);
      background: -webkit-linear-gradient(164deg,#00d301,#36c275 50%,#00a562);
      background: linear-gradient(286deg,#00d301,#36c275 50%,#00a562);
  }

</style>
<style>

.capture672 .theme--light.v-input:not(.v-input--is-disabled) input {
    color: #fff;
}
.capture672 .theme--light.v-label {
    color: #fff;
}
.capture672 input:-webkit-autofill,
.capture672 input:-webkit-autofill:hover,
.capture672 input:-webkit-autofill:focus,
.capture672 input:-webkit-autofill:active  {
    -webkit-box-shadow: 0 0 0 80px rgba(102, 175, 233, 0.1) inset !important;
    background-color: rgba(102, 175, 233, 0.1)  !important;
    background-clip: content-box !important;
}
.capture672 input:-webkit-autofill,
.capture672 input:-webkit-autofill:hover,
.capture672 input:-webkit-autofill:focus,
.capture672 input:-webkit-autofill:active {
    -webkit-animation: autofill 0s forwards;
    animation: autofill 0s forwards;
}
.capture672 input:-webkit-autofill, capture672 input:-webkit-autofill:focus {
  box-shadow: 0 0 0 1000px white inset;
  -webkit-text-fill-color: #fff;
}
@keyframes autofill {
    100% {
        background: transparent;
        color: inherit;
    }
}


@-webkit-keyframes autofill {
    100% {
        background: transparent;
        color: inherit;
    }
}

input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus textarea:-webkit-autofill,
  textarea:-webkit-autofill:hover textarea:-webkit-autofill:focus,
  select:-webkit-autofill,
  select:-webkit-autofill:hover,
  select:-webkit-autofill:focus {
    -webkit-box-shadow: 0 0 0px 1000px #ffffff inset !important;
  }
</style>
<template>
  <v-app id="signup">
   
    <v-content class="gradient-mask">
      <v-container fluid fill-height  class="legaldocflow">
        <v-layout align-right justify-right row wrap>
          <v-flex xs4 xl3 class="left-section" hidden-sm-and-down>
              <div class="inner-left">
                 <a href="https://www.legaldocflow.com/">
              <img alt="Legaldocflow Logo" src="https://static.wixstatic.com/media/158464_3a9d65b3794546e3921281fb7af40f5a~mv2.png/v1/fill/w_223,h_40,al_c,q_85,usm_0.66_1.00_0.01/logo_legaldocflow-01.webp">
              </a>
              
                <h3 style="font:49px raleway">Legal Document
                   Workflow
                  Automated
                  </h3>
                  <p style="color: #9181DC;font:20px">Automate your customer agreement procedures hassle-free with e-signature functionality built-in</p>
              
              </div>

          </v-flex>
          <v-flex xs12 sm12 md8 lg8 xl9 style="text-align: center" class="right-section" >
            <img :style="image.style" :src="image.url" v-if="image" />
            <img style="margin-top: 80px" height="160" src="../assets/login.png" v-else />
            
            <v-alert :value="true" type="error" v-if="error">
              We couldn’t find an account matching the username and password you entered. Please check your username and password and try again.
            </v-alert>
            <form id="sign-in-form" @submit.prevent="submit()">
            <v-card width=500 elevation="0" class="card-height">
              <v-card-text>
                  <v-text-field prepend-icon="email" v-model="username" name="username"  v-validate="'required'" :error-messages="errors.collect('username')" label="Username"></v-text-field>
                  <v-text-field id="password" v-model="password"  name="password" :error-messages="errors.collect('password')" prepend-icon="lock"  label="Password" type="password" v-validate="'required'" ref="password"></v-text-field>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn round :loading="loading" dark color="purple" type="submit" form="sign-in-form" class="button-green-gradient btn">Sign In</v-btn>
              </v-card-actions>
            </v-card>
            </form>
            <p class="text-md-center">
              <br />
              <br />
              <!--
              <span v-if="subDomain != 'wfs'"> Not a member? <router-link :to="{name: 'signup'}"> Sign up now </router-link></span>
            -->
              <br />
              <br />
              <br />
              <br />
            </p>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>

import {createNamespacedHelpers} from 'vuex';
const host = window.location.host;
let hostname = window.location.hostname;
// hostname = 'admin.capture672.com';

let parts = host.split('.');
const subDomain = parts.length && parts[0] ? parts[0].toLowerCase() : '';
const { mapActions, mapMutations } = createNamespacedHelpers('users');
import {clearStorage} from '@/services/localstorage.service';


  export default {
    data: () => ({
      imageUrl: '../assets/logo-white-bg.svg',
      image: null,
      signupClass: '',
      hostname: hostname,
      subDomain: subDomain,
      drawer: null,
      error: false,
      username: '',
      password: '',
      loading: false,
    }),
    props: {
      source: String,
      options: Object
    },
    methods: {
      ...mapActions(['aSignIn']),
      ...mapMutations(['mPurgeAuth']),
      submit() {
        const payload = {
          username: this.username,
          password: this.password
        };
        let signIn = this.signIn;
        this.$validator.validateAll().then(function(response) {
          if(response === true) { 
              signIn(payload); 
            }
        }).catch(function(e) {});
      },
      signIn(payload) {
        let progress = this.$Progress;
        let router = this.$router;
        const signIn = this.aSignIn;
        let $this = this;
        progress.start();
        $this.loading = true;
        signIn(payload).then(function(response) {
          progress.finish();
          router.push({name: 'projects-home'});
          $this.loading = false;
        }).catch(function(e) { 
          $this.loading = false;
          progress.finish(); 
          $this.error = true; 
          });
      },
      setImage() {
        try {
          const image = this.options.image;
          if(image) {
            this.image = image;
          }
          
        } catch(error) {

        }
      }
    },
    mounted() {
      this.mPurgeAuth();
      clearStorage();

      console.log('options', this.options);

      this.imageUrl = '../assets/logo-white-bg.svg';
      this.setImage();
    

      if(this.hostname == 'admin.capture672.com') {
        this.signupClass = 'capture672';
      }
      if(this.hostname == 'admin-test.capture672.com') {
        this.signupClass = 'capture672';
      }
      if(this.hostname == 'admin.legalworkflow365.com') {
        this.signupClass = 'legalworkflow365';
        // this.imageUrl = ' https://legalworkflow365-public.s3.eu-west-2.amazonaws.com/legalworkflow365.png';
      }
      // this.$validator.localize('en', this.dictionary);
    },
    beforeCreate() {
    }
  }
</script>
